import React, { Component } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { Link } from "react-router-dom"
import { Profile, Logo } from "./Fragments"

class Logout extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount = () => {
        let span = document.getElementById("logoSpan")
        span.style = "animation-name: anim;"
        localStorage.removeItem("jwtToken")
        localStorage.removeItem("authUser")
        setTimeout(() => (span.style = ""), 3000)
    }

    render() {
        return (
            <React.Fragment>
                <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-dark">
                        <i className="bx bx-home h2" />
                    </Link>
                </div>
                <div className="account-pages my-5 pt-sm-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden">
                                    <Profile
                                        title="See you soon!"
                                        message="You have been sucessfully logged out."
                                    ></Profile>
                                    <CardBody className="pt-0">
                                        <Logo></Logo>
                                        <div className="p-2"></div>
                                    </CardBody>
                                </Card>
                                <div className="mt-5 text-center">
                                    <p>
                                        Already have an account ?{" "}
                                        <Link to="/login" className="fw-medium text-primary">
                                            {" "}
                                            Login
                                        </Link>{" "}
                                    </p>
                                    <p>© {new Date().getFullYear()} idexo.io</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default Logout
